import { Navigate } from 'react-router-dom'

import { useHasAccessToBufferHome } from '~publish/hooks/useHasAccessToBufferHome'

import HomePage from './HomePage'

import type { JSX } from 'react'

/**
 * Route handler for `/home`. Renders the Buffer Home page for organization
 * owners, and redirects everyone else back to `/` so the default router can
 * route them to their normal schedule view.
 *
 * Hold the render until the account has actually resolved so users don't flash
 * the wrong page while ownership is still loading.
 */
export const HomeRoute = (): JSX.Element => {
  const { hasAccess, loading } = useHasAccessToBufferHome()

  if (loading) {
    return <></>
  }

  if (!hasAccess) {
    return <Navigate to="/" replace />
  }

  return <HomePage />
}
